import React from "react"

class FormFieldsDataType extends React.Component{
  
  constructor(props) {
    super(props);
  }

  render() {
    var form_fields
    if(this.props.row.form_fields) {
        form_fields = this.props.row.form_fields.sort((a,b) => a.position - b.position).map((form_field, index) => {
        return (
          <li key={form_field.id}>{`${form_field.field}`}<i>{` (${I18n.t(form_field.field_type)})`}</i></li>
        )
      }) 
    }
    return (
      <div>
        { form_fields.length > 0 
        ? <ul>{form_fields}</ul>
        : <i>{I18n.t("none")}</i> }
      </div>
    )
  } 
}

export default FormFieldsDataType